<script>
/* globals window */

var calculator_component = function() {

    var parseNumber = function(n) {
        n = Number(n) || 0;
        return n;
    };

    var round = function(n) {
        return Math.round(n*100)/ 100;
    };
    var money = function(n) {
        n = parseNumber(n);
        return n.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    };

    var roundMoney = function(money) {
        return Math.floor(money);
    }

    var roundPercent = function(percent) {
        return Math.floor(percent*1000)/1000;
    }

    var getDownPayment = function(price, down_payment, du) {
        price = parseNumber(price);
        down_payment = parseNumber(down_payment);
        var d = down_payment;
        if (du !== '$') d = down_payment / 100 * price;
        return roundMoney(d);
    };

    var getPercentFromDollarDownPayment = function(price, down_payment) {
        price = parseNumber(price);
        down_payment = parseNumber(down_payment);
        var p = (down_payment / price) * 100;
        return roundPercent(p);
    };

    var getTotalLoanValue = function(price, down_payment, du) {
        price = parseNumber(price);
        down_payment = parseNumber(down_payment);
        var down = getDownPayment(price, down_payment, du);
        return price - down;
    };

    var getEffectiveInterestRate = function(apr, per_year) {
        per_year = per_year || 12;

        // Effective Interest rate is a fraction of 1, instead of a %.
        // Should be split into 12 assuming 12 payments per year.
        return (apr / 100) / per_year;
    };

    var mortgageCalc = function(price, down, du, apr, term = 30, tax = 0, fees = {}) {


        price = parseNumber(price);
        down = parseNumber(down);
        var P = getTotalLoanValue(price, down, du);
        var J = getEffectiveInterestRate(apr, 12);
        var N = 0 - (term*12);
        var mortgage = 0;

        if (J == 0) {
            mortgage = P / (term * 12);
        } else {
            mortgage = P * ( J / ( 1 - Math.pow(1 + J, N)));
        }

        //var taxAmount = (price * (tax / 100)) / 12;
        // using dollars instead of percent
        var taxAmount = tax;
        taxAmount = round(taxAmount);
        mortgage = parseFloat(mortgage.toFixed(2)); // + taxAmount;

        //return mortgage;
        var res = Object.assign(fees, { tax: taxAmount, mortgage: mortgage });

        return res;

    };

    var _default_calculator_settings = {
        purchase_price: 0,
        down_payment: 0,
        down_payment_units: '%',
        interest_rate: 4.5,
        pmi_rate: 0,
        est_property_tax_rate: 0.0185334, // millage rate
        water_sewage: 290.01,
        est_community_fees: 0,
        est_homeowner_fees: 0,
        term: 30,
    };

    return {
        mounted() {
            this.$nextTick(function () {
                var _calculator_settings = Object.assign(
                    {}, _default_calculator_settings,
                    this.calculatorSettings
                );

                this.purchase_price = _calculator_settings.purchase_price;
                this.down_payment = _calculator_settings.down_payment;
                this.down_payment_units = _calculator_settings.down_payment_units;
                this.interest_rate = _calculator_settings.interest_rate;
                this.term = _calculator_settings.term;
                this.est_property_tax_rate = _calculator_settings.est_property_tax_rate;
                this.water_sewage = _calculator_settings.water_sewage;
                this.pmi_rate = this.pmi || _calculator_settings.pmi_rate;
                this.est_homeowner_insurance = this.homeownerInsurance;

                //this.est_community_fees = _calculator_settings.est_community_fees,
                //this.est_homeowner_fees = _calculator_settings.est_homeowner_fees;

                this.purchase_price = this.homePrice;
                this.est_homeowner_fees = this.estHoaFees;
                this.est_community_fees = this.estCddFees;
            });
        },
        data() {
            return {
                total: 0,
                ..._default_calculator_settings,
                state: true,
                selectedCommunity: { id: false },
                selectedResidence: { id: false },
                est_property_taxes: 0,
                est_pmi_fees: 0,
                down_payment: 0,
                pmi_rate: 0,
                est_homeowner_insurance: 0,
            }
        },
        props: [
            'modalData',
            'calculatorSettings',
            'communities',
            'homePrice',
            'estMonthlyTaxes',
            'estHoaFees',
            'estCddFees',
            'pmi',
            'homeownerInsurance',
            'communityName',
            'floorplanName',
        ],
        computed: {
            residences: function() {
              if (typeof this.communities === 'undefined') return [];
              if (this.communities.length === 0) return [];

              return this.communities
                .map((community) => { return Object.values(community.residences); })
                .reduce((acc, val) => acc.concat(val));
            },
            filteredResidences: function() {
              let results = this.residences;
              if (this.selectedCommunity && this.selectedCommunity.id) {
                results = results
                  .filter((c) => { return c.community_id == this.selectedCommunity.id })
                ;
              }

              return results;
            },

            chartData: function() {
                var c = this.calculate;
                return {
                 labels: ['Principal Interest', 'Taxes', 'Fees/Dues'],
                  datasets: [
                    {
                      //label: 'Taxes',
                      backgroundColor: ['#0d415a', '#FFD24F', '#F8981D'],
                      borderColor: ['#0d415a', '#FFD24F', '#F8981D'],
                      data: [c.mortgage, c.tax, c.hoa + c.cdd + c.pmi]
                    },
                  ]
                }
            },
            calculate: function(){
                return mortgageCalc(
                    this.purchase_price,
                    this.down_payment,
                    this.down_payment_units,
                    this.interest_rate,
                    this.term,
                    this.est_property_taxes,
                    { 
                        cdd: parseFloat(this.est_community_fees) || 0,
                        hoa: parseFloat(this.est_homeowner_fees) || 0,
                        homeowner_insurance: parseFloat(this.est_homeowner_insurance) || 0,
                        pmi: parseFloat(this.est_pmi_fees) || 0
                    }
                );
            },
            calculatePmi: function() {
                // This is an FHA Mortgage. The mortgage insurance does not end
                // at 20 percent.
                if(!this.purchase_price) {
                    return 0;
                }

                return (
                    (this.purchase_price - this.downPaymentAmt) * 
                    this.pmi_rate / 12
                ).toFixed(2);
            },
            displayEstMonthlyPmi: function() {
                return money(this.est_pmi_fees);
            },
            totalAmtPerMonth: function() {
                return money(
                    this.calculate.mortgage + 
                    this.calculate.tax + 
                    this.calculate.cdd + 
                    this.calculate.hoa +
                    this.calculate.homeowner_insurance +
                    this.calculate.pmi
                )
            },
            downPaymentAmt: function() {
                return getDownPayment(
                    this.purchase_price,
                    this.down_payment,
                    this.down_payment_units
                );
            }
        },
        watch: {
            purchase_price: {
                immediate: true,
                handler(is, was) {
                    if(is === was || !is) return;

                    if(is <= 50000) {
                        return this.est_property_taxes = 0;
                    }

                    this.est_property_taxes = ((
                        (is * 0.80 - 50000) * this.est_property_tax_rate + this.water_sewage
                    ) / 12).toFixed(2);

                    this.est_pmi_fees = this.calculatePmi;
                }
            },
            down_payment: function(is, was) {
                if(is === was || !is) return
                this.est_pmi_fees = this.calculatePmi;
            },
            modalData: function(data) {
                if(!data || !data.purchasePrice) return;
                purchase_price = data.purchasePrice;
            },
            down_payment_units: function(is, was) {
                if (is === was) return;

                if (is == '%') {
                    this.down_payment = getPercentFromDollarDownPayment(this.purchase_price, this.down_payment);
                    return '%';
                }

                if (is == '$') {
                    this.down_payment = getDownPayment(this.purchase_price, this.down_payment, 0, '%');
                    return '$';
                }
            },
            selectedCommunity: function(is, was) {
                if (!is) return;

                if (!is.id) {
                    return this.selectedResidence = {id: false};
                }

                this.est_community_fees = is.est_community_fees;
                this.est_homeowner_fees = is.est_homeowner_fees;
                this.est_homeowner_insurance = is.est_homeowner_insurance;
                // this.est_property_taxes = is.est_property_taxes;
            },
            selectedResidence: function(is, was) {
                if (!is) return;

                if(is.id) {
                    this.purchase_price = is.price;
                }
            }
        },
        methods: {
            money: money,

            displayPurchasePrice: function() {
                return money(this.purchase_price);
            },
            displayEstHomeownerFees: function() {
                 return money(this.est_homeowner_fees);
            },
            displayCddMonthlyFees: function() {
                return money(this.est_community_fees);

            },
            displayDownPayment: function() {
                return money(this.downPaymentAmt);
            },
            displayTotal: function() {
                return money(getTotalLoanValue(
                    this.purchase_price,
                    this.down_payment,
                    this.down_payment_units
                ));
            },
            displayPayments: function() {
                return this.calculate;
            }
        }
    }
}();

export default calculator_component;


</script>



// WEBPACK FOOTER //
// resources/components/apps/calculator.vue